import React, { useEffect, useRef, useState } from "react";
import styles from "./CategoriesDetail.module.css";
import engineer from "../../assets/profile2.png";
import engineer2 from "../../assets/man1.png";
import engineer3 from "../../assets/woman1.png";
import engineer5 from "../../assets/man2.png";
import engineer6 from "../../assets/woman2.png";
import { List } from "antd";
import { useLocation } from "react-router-dom";
import { SearchInput } from "../../components";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CategoriesMiddleware from "../../store/Middlewares/CategoriesMiddleware";
import { IMG_URL } from "../../store/Apis";
import dummyImg from "../../assets/dummy.png";

function CategoriesDetail() {
  const { state } = useLocation();
  // const [search, setsearch] = useState();
  // const { t } = useTranslation();

  useEffect(() => {
    getSubCategories();
    getLanguage();
  }, []);
  

  const CategoryID = state?.id
  const [search, setSearch] = useState('')
  const {t , i18n} = useTranslation();
  const dispatch = useDispatch();
  const CastodialList = useSelector(state => state.CategoriesReducer.CleanerCategoryList)
  const CastodialListPagination = useSelector(state => state.CategoriesReducer.CleanerCategoryPagination)
  const timeout=useRef(null);

  const getLanguage = async () => {
    try {
        const language = localStorage.getItem('@selectedLanguage');
        i18n.changeLanguage(language)
    } catch (e) {
        console.log(e)
    }
  };

  const getSubCategories = () => {

    let data= {
      id: CategoryID,
      search: search,
      next_page_url: undefined
    }
    
    dispatch(CategoriesMiddleware.getSubCategories( data ))
  }



  const onSearchSubCategories = (text) => {
    let data= {
      id: CategoryID,
      search: text,
      next_page_url: undefined
    }
    setSearch(text);
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      dispatch(CategoriesMiddleware.getSubCategories(data))     
    }, 1000);
  }

   

    const onPressLoadMore = () => {
      let data= {
        id: CategoryID,
        search: search,
        next_page_url: CastodialListPagination?.links?.next
      }
      dispatch(CategoriesMiddleware.getSubCategories(data))
    };


  const loadMore =
  CastodialListPagination?.links?.next ? (
    <div
      style={{
        textAlign: 'center',
        marginTop: 12,
        height: 32,
        lineHeight: '32px',
        display: 'flex', justifyContent: 'center'
      }}
    >
      <button onClick={onPressLoadMore} className={styles.loadMore_button}>
        Load More
      </button>
    </div>
  ) : null;

  

  const renderItem = (item) => {
    return (
      <div className={styles.box_item}>
        <img src={item?.profile_image ? IMG_URL + item?.profile_image : dummyImg} className={styles.image} />
        <div className={styles.heading_view}>
          <h2 className={styles.tab_heading}> {item?.name}</h2>
          <text className={styles.text}>{t(item?.category_name)}</text>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.heading}>{t(state?.name)}</h1>

      <div className={styles.used_search_input}>
        <SearchInput
          placeholder={t("Search")}
          onChange={(e) => onSearchSubCategories(e.target.value)}
        />
      </div>

      <List
        style={{ width: "100%" }}
        grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
        dataSource={CastodialList}
        footer={loadMore}
        renderItem={renderItem}
      />
    </div>
  );
}

export default CategoriesDetail;
